






import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BankAccountWrapper from '@/components/bankAccount/BankAccountWrapper.vue';
import { BankAccount } from '@/store/mangoPay/types';


@Component({
  name: 'bank-account-details-view',
  components: {
    BankAccountWrapper,
  },
})
export default class BankAccountDetailsView extends Vue {
  @Getter('mangoPay/getBankAccountById') getBankAccountById?: Function;
  private bankAccount: BankAccount = null;

  created() {
    const bankAccountId = this.$route.params.accountId;
    this.bankAccount = this.getBankAccountById(bankAccountId);
  }
}
